import React, { useState, useEffect } from "react";
import { Eye, EyeOff, Edit } from "react-feather";  
import axios from "axios"; // Import axios
import { baseurl } from "../Baseurl";
import { useNavigate, Link } from "react-router-dom";
import Swal from 'sweetalert2';
import VisitorNavbar from "../component/VisitorNavbar";
import VisitorSidebar from "../component/VisitorSidebar";

const CustomerProfile = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [customerData, setCustomerData] = useState({
    first_name: "",
    middle_name: "",
    last_name: "",
    customer_email: "",
    phone: "",
    country: "",
    region: "",
  });

  const [countries, setCountries] = useState([]);

  useEffect(() => {
    axios.get(`${baseurl}getAllCountries`).then((res) => {
      setCountries(res.data.countries || []);
    });
  }, []);

  const [loading, setLoading] = useState(true);
  const cust_id = localStorage.getItem("cust_id");  
   

  console.log("cust_id", cust_id);

  useEffect(() => {
    const fetchCustomerData = async () => {
      try {
        const response = await axios.get(`${baseurl}fetchCustomerById/${cust_id}`);
        if (response.data.message === "Customer data fetched successfully.") {
          setCustomerData(response.data.data); // Set the fetched data
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching customer data:", error);
        setLoading(false);
      }
    };

    if (cust_id) {
      fetchCustomerData();
    }
  }, [cust_id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCustomerData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

 const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true); // start loader

  const updatedData = {
    ...customerData,
    cust_id: cust_id,
  };

  try {
    const response = await axios.post(`${baseurl}update_customer`, updatedData);

    if (response.data.message === "Customer data updated successfully.") {
      Swal.fire({
        icon: 'success',
        title: 'Profile updated successfully',
        text: 'Your profile has been updated.',
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Failed to update profile',
        text: 'There was an issue updating your profile. Please try again.',
      });
    }
  } catch (error) {
    console.error("Error updating customer data:", error);
    Swal.fire({
      icon: 'error',
      title: 'An error occurred',
      text: 'There was an issue with the server. Please try again later.',
    });
  } finally {
    setLoading(false); // stop loader
  }
};


  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      
      <VisitorNavbar/>
      <div>
        <section className="mb-5">
          <div className="container-fluid">
            <div className="row my-3 g-2 justify-content-center">
              <div className="col-md-2 hide-on-mobile">
                <VisitorSidebar/>
              </div>

              <div className="col-md-10">
                <div className="reviewcls text-start">
                  <h4 className="selh1">My Account</h4>
                  <p className="payttl">
                    Please update your profile information.
                  </p>
                  <hr />
                  <form className="contact-form text-start" onSubmit={handleSubmit}>
                    <div className="row g-2">
                      <div className="col-md-4">
                        <label htmlFor="first_name" className="form-label">
                          First Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="first_name"
                          name="first_name"
                          className="form-control"
                          placeholder="Enter your first name"
                          value={customerData.first_name || ''}
                          onChange={handleInputChange}
                          required
                        />
                      </div>

                      <div className="col-md-4">
                        <label htmlFor="middle_name" className="form-label">
                          Middle Name 
                        </label>
                        <input
                          type="text"
                          id="middle_name"
                          name="middle_name"
                          className="form-control"
                          placeholder="Enter your Middle Name"
                          value={customerData.middle_name || ''}
                          onChange={handleInputChange}
                        />
                      </div>

                      <div className="col-md-4">
                        <label htmlFor="last_name" className="form-label">
                          Last Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="last_name"
                          name="last_name"
                          className="form-control"
                          placeholder="Enter your last name"
                          value={customerData.last_name || ''}
                          onChange={handleInputChange}
                          required
                        />
                      </div>

                      <div className="col-md-12">
                        <label htmlFor="email" className="form-label">
                          Email<span className="text-danger">*</span>
                        </label>
                        <input
                          type="email"
                          id="email"
                          name="user_email"
                          className="form-control"
                          placeholder="Enter your email address"
                          value={customerData.user_email || ''}
                          onChange={handleInputChange}
                          disabled
                        />
                        {/* <div className="text-end">
                        <small><Link className="editemail"><Edit size={15}/>&nbsp;Update Email</Link></small>
                        </div> */}
                      </div>

                      <div className="col-md-12">
  <label htmlFor="phone" className="form-label">
    Phone Number<span className="text-danger">*</span>
  </label>
  <input
    type="text"  // Use "text" instead of "number" to control input better
    id="phone"
    name="phone"
    className="form-control"
    placeholder="Enter your phone number"
    value={customerData.phone || ""}
    onChange={(e) => {
      const input = e.target.value;
      // Allow only digits, and limit to 10 characters
      if (/^\d{0,10}$/.test(input)) {
        handleInputChange(e);
      }
    }}
    maxLength={10} // Ensures input box does not allow more than 10 characters
  />
</div>


                      <div className="col-md-6">
                        <label htmlFor="country" className="form-label">
                          Country<span className="text-danger">*</span>
                        </label>
                        {/* <input
                          type="text"
                          id="country"
                          name="country"
                          className="form-control"
                          placeholder="Enter your country"
                          value={customerData.country || ""}
                          onChange={handleInputChange}
                        /> */}
                       <select
      id="country"
      name="country"
      className="form-control"
      value={customerData.country || ""}
      onChange={handleInputChange}
    >
      <option value="">Select Country/Region</option>
      {countries.map((c) => (
        <option key={c.id} value={c.country_name}>
          {c.country_name}
        </option>
      ))}
    </select>
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="region" className="form-label">
                          Region<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="region"
                          name="region"
                          className="form-control"
                          placeholder="Enter your region"
                          value={customerData.region || ""}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="mt-3 text-end">
                      <button type="submit" className="btn submitbtnn w-25" disabled={loading}>
  {loading ? (
    <>
      <span
        className="spinner-border spinner-border-sm me-2"
        role="status"
        aria-hidden="true"
      ></span>
      Updating...
    </>
  ) : (
    "Update"
  )}
</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default CustomerProfile;
